import { Fragment } from 'react';

import { DownOutlined } from '@ant-design/icons';

import * as St from './NavStepper.styles';

import { FocusElement } from '~/core/enums';
import { useNavigationContext } from '~/legacy/easy-estimator-page/context/navigationContext';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { selectFocusElement, toggleFocusElement } from '~/redux/slices/layout';
import StepNumber from '~atoms/StepNumber';
import NavStep from '~molecules/NavStep';

const NavStepper = () => {
  const dispatch = useAppDispatch();

  const { navSteps, goToAndFocusStep } = useNavigationContext();

  const focusElement = useAppSelector(selectFocusElement);
  const currentStepIndex = Math.max(
    navSteps.findIndex((step) => step.isCurrent),
    0
  );
  const currentStep = navSteps[currentStepIndex];
  const isNavBarExpanded = focusElement === FocusElement.MOBILE_NAV_BAR;

  const toggleDropDown = () =>
    dispatch(toggleFocusElement(FocusElement.MOBILE_NAV_BAR));

  return (
    <>
      <St.Backdrop
        data-is-expanded={isNavBarExpanded}
        onClick={toggleDropDown}
      />
      <St.Container>
        <St.MobileNavStepTrigger
          {...currentStep}
          onClick={toggleDropDown}
          beforeChildren={<DownOutlined data-is-expanded={isNavBarExpanded} />}
        >
          <StepNumber>{currentStepIndex + 1}</StepNumber>
          {currentStep.label}
        </St.MobileNavStepTrigger>

        <St.Content data-is-expanded={isNavBarExpanded}>
          <St.NavigationList>
            {navSteps.map((step, stepNumber) => (
              <Fragment key={`nav-step-${step.stepName}`}>
                <li {...(step.isCurrent ? { 'aria-current': 'step' } : {})}>
                  <NavStep
                    {...step}
                    onClick={() => goToAndFocusStep(step.stepName)}
                  >
                    <StepNumber>{stepNumber + 1}</StepNumber>
                    {step.label}
                  </NavStep>
                </li>
                {stepNumber < navSteps.length - 1 && (
                  <St.Divider aria-hidden="true" />
                )}
              </Fragment>
            ))}
          </St.NavigationList>
        </St.Content>
      </St.Container>
    </>
  );
};

export default NavStepper;
